<!-- Template for the window content -->
<ng-template #windowContent>
  <!-- Grid -->
  <div class="grid-container">
    <kendo-grid
      #grid
      [mvcDataSource]="dataSource"
      [rowHeight]="36"
      [pageable]="true"
      [sortable]="true"
      [filterable]="true"
      [selectable]="true"
      [scrollable]="'virtual'"
      [pageSize]="20"
      [filter]="currentFilter!"
      (filterChange)="onFilterChange($event)"
      (selectionChange)="onRowSelect($event)"
      [attr.aria-label]="'Search results grid. Use arrow keys to navigate, Enter to select'"
      role="grid">
      <!-- Dynamically create grid columns -->
      <kendo-grid-column *ngFor="let column of columnComponents" 
                        [field]="column.field" 
                        [title]="column.title || getSearchFieldLabel(column.field)" 
                        [width]="column.width" 
                        [format]="column.format"
                        [filterable]="column.filterable"
                        [sortable]="column.sortable"
                        [hidden]="column.hidden"
        [minResizableWidth]="column.minResizableWidth">
      </kendo-grid-column>
    </kendo-grid>
  </div>
</ng-template>